"use strict";
(() => {
    // The script tag is included once per section that shows ratings — only
    // run once, since every run processes all badges on the page.
    const w = window;
    if (w.__macadeCollectionRating)
        return;
    w.__macadeCollectionRating = true;
    const script = document.querySelector('script[data-yotpo-id]');
    const yotpoId = script === null || script === void 0 ? void 0 : script.dataset.yotpoId;
    const badges = document.querySelectorAll('[data-macade-rating-badge]');
    if (!yotpoId || !badges.length)
        return;
    const productIds = [];
    const seen = {};
    badges.forEach((b) => {
        const id = b.dataset.productId;
        if (id && !seen[id]) {
            seen[id] = true;
            productIds.push(id);
        }
    });
    // One batched request for every product on the page instead of one
    // request per product. Results come back in the same order as `methods`.
    fetch('https://staticw2.yotpo.com/batch', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            app_key: yotpoId,
            methods: productIds.map((pid) => ({
                method: 'bottomline',
                params: { pid },
                format: 'json',
            })),
        }),
    })
        .then((res) => {
        if (!res.ok)
            throw new Error(`Yotpo batch responded ${res.status}`);
        return res.json();
    })
        .then((entries) => {
        entries.forEach((entry, index) => {
            var _a, _b;
            const productId = productIds[index];
            const score = (_a = entry.result) === null || _a === void 0 ? void 0 : _a.average_score;
            const total = (_b = entry.result) === null || _b === void 0 ? void 0 : _b.total;
            if (!productId || !score || !total)
                return;
            document
                .querySelectorAll(`[data-macade-rating-badge][data-product-id="${productId}"]`)
                .forEach((badge) => {
                const scoreEl = badge.querySelector('[data-rating-score]');
                if (scoreEl) {
                    scoreEl.textContent = score.toFixed(1);
                    badge.style.display = '';
                    badge.setAttribute('aria-label', `${score.toFixed(1)} out of 5 stars, ${total} reviews`);
                }
            });
        });
    })
        .catch((error) => {
        console.error('Failed to fetch Yotpo ratings', error);
    });
})();
